var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"carousel",staticClass:"electric-vehicle-soft-search__last-step-vehicle-carousel"},_vm._l((_vm.vehicles),function(vehicle){return _c('div',{key:vehicle.id,staticClass:"electric-vehicle-soft-search__slick-padding"},[(vehicle !== null)?_c('soft-search-vehicle',{attrs:{"vehicle":vehicle,"electricOrHybrid":_vm.electricOrHybrid}}):_vm._e()],1)}),0)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8239eae","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/soft-search/SoftSearchCarousel.vue
// module id = o1WW
// module chunks = 46